
/*
  This component will display configurator count in configurator
 */

import React from 'react'
import {useSelector} from "react-redux";

const StepCounter = (props) => {
    const attributes = useSelector(state => state.productSelectionsReducer.requiredAttributes);
    const selections = useSelector(state => state.productSelectionsReducer.requiredSelections);
    const sides = useSelector(state => state.patternSelectionsReducer.sides);

    const getCount = () => {
        let total_steps = attributes.length + 1; // +1 because we also need take into account Product
        let current_step = selections.length;

        /*
            In the original start counter we start with Product and then count attributes,
            so to replicate that we do following hack:

            We wait until all the attribute steps are completed, and when the last attribute is filled
            we add +1 to the current step to account for a Product
         */
        if ((current_step + 1 == total_steps)  && selections[current_step-1]['selection']) {
            current_step = current_step + 1;
            if(sides) {
                current_step = current_step + Object.keys(sides).length; //add all sides at once
                total_steps = total_steps +  Object.keys(sides).length; //update total as well
            }

        }
        
        return  current_step +'/' + total_steps + ' questions completed';
    }

    if(!attributes || selections.length == 0){
        return null;
    }

    return (
                <div className='configurator-count'>
                     <p>
                         {getCount()}
                     </p>
                </div>
    )
    
}
export default StepCounter;